import { render, staticRenderFns } from "./Asset-Dashboard.vue?vue&type=template&id=540f01ac&"
import script from "./Asset-Dashboard.vue?vue&type=script&lang=ts&"
export * from "./Asset-Dashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports